// extracted by mini-css-extract-plugin
export default {"header":"Analysis_header__9ms8O","menu":"Analysis_menu__OEA8t","anticon":"Analysis_anticon__UZ429"};